var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("404 - 页面不存在")]),_c('el-button',{on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }